import { parseAsBoolean, useQueryState } from 'nuqs';

export const useHistoryDialog = () => {
  const [isOpen, setIsOpen] = useQueryState('pis-activity', parseAsBoolean.withDefault(false));

  return {
    isOpen,
    setIsOpen,
  };
};
